import _classCallCheck from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/createClass.js";
import debounce from "lodash/debounce";
import { EventHandler } from "../utils/events";
export var bpList = ["s", "m", "l", "xl"];
export var bpEvents = {
  SET: "breakpoint:set",
  UPDATED: "breakpoint:updated"
};
export var BreakpointObserver = /*#__PURE__*/function () {
  function BreakpointObserver() {
    _classCallCheck(this, BreakpointObserver);

    this._current = null;
    this._boundUpdate = this._update.bind(this);
    this._events = EventHandler;

    this._init();
  }

  _createClass(BreakpointObserver, [{
    key: "current",
    get: function get() {
      return this._current;
    }
  }, {
    key: "_init",
    value: function _init() {
      // force layout reflow for ie11 only
      if (navigator.appVersion.indexOf("Trident/7.0") !== -1) {
        document.body.getBoundingClientRect();
      }

      this._current = this._getBreakpoint();
      typeof window !== "undefined" && this._events.on(window, "resize", debounce(this._boundUpdate, 100));
    }
  }, {
    key: "_getBreakpoint",
    value: function _getBreakpoint() {
      var bp = typeof window !== "undefined" && window.getComputedStyle(document.body, ":before").content.replace(/"/g, "");

      if (bp === "none" || bp === null) {
        typeof window !== "undefined" && window.setTimeout(this._boundUpdate, 1000);
      }

      return bp;
    }
  }, {
    key: "_update",
    value: function _update() {
      var prevBreakpoint = this._current;
      this._current = this._getBreakpoint();

      if (this._current !== prevBreakpoint) {
        this._events.trigger(document, bpEvents.UPDATED, this._current);
      }
    }
  }]);

  return BreakpointObserver;
}();